// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1nisi","label":"SetPasswdForm_label__sosId"};